export default __webpack_public_path__ + "static/media/mobile-app-deposit-ico.ee505bec.svg";